(function () {
  if (window.__scKlaviyoBisInstalled) return;
  window.__scKlaviyoBisInstalled = true;

  var REVISION = '2026-04-15';

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
      window.location.pathname.indexOf('/products/') !== -1;
  }

  if (!isProductPage()) return;

  function isArabic() {
    return document.documentElement.classList.contains('rtl_true') ||
      document.documentElement.getAttribute('dir') === 'rtl' ||
      String(document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') !== -1;
  }

  function t(en, ar) {
    return isArabic() ? ar : en;
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : (fallback || 0);
  }

  function toBool(value) {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    return null;
  }

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function normalizeCity(value) {
    var text = normalizeText(value);

    if (!text) return '';

    /*
      City group mapping used by Sharbatly:
      Jeddah group: Jeddah / Makkah / Taif / Madinah
      Riyadh group: Riyadh / Al Kharj
      Dammam group: Dammam / Jubail / Al Hasa
    */

    if (
      text === 'jd' ||
      text === 'city: jd' ||
      text.indexOf('jeddah') !== -1 ||
      text.indexOf('jedda') !== -1 ||
      text.indexOf('جدة') !== -1 ||
      text.indexOf('makkah') !== -1 ||
      text.indexOf('mecca') !== -1 ||
      text.indexOf('مكة') !== -1 ||
      text.indexOf('taif') !== -1 ||
      text.indexOf('الطائف') !== -1 ||
      text.indexOf('madinah') !== -1 ||
      text.indexOf('medina') !== -1 ||
      text.indexOf('المدينة') !== -1
    ) {
      return 'jeddah';
    }

    if (
      text === 'rd' ||
      text === 'city: rd' ||
      text.indexOf('riyadh') !== -1 ||
      text.indexOf('الرياض') !== -1 ||
      text.indexOf('al kharj') !== -1 ||
      text.indexOf('alkharj') !== -1 ||
      text.indexOf('الخرج') !== -1
    ) {
      return 'riyadh';
    }

    if (
      text === 'dm' ||
      text === 'city: dm' ||
      text.indexOf('dammam') !== -1 ||
      text.indexOf('الدمام') !== -1 ||
      text.indexOf('jubail') !== -1 ||
      text.indexOf('الجبيل') !== -1 ||
      text.indexOf('hasa') !== -1 ||
      text.indexOf('hassa') !== -1 ||
      text.indexOf('ahsa') !== -1 ||
      text.indexOf('الأحساء') !== -1 ||
      text.indexOf('الاحساء') !== -1
    ) {
      return 'dammam';
    }

    return '';
  }

  function getConfig() {
    return window.scKlaviyoBisConfig || {};
  }

  function getProductData() {
    var el = document.getElementById('sc-bis-product-json');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      console.warn('[SC BIS] product JSON parse failed', e);
      return null;
    }
  }

  var productData = getProductData();

  function getBisWrap() {
    return document.querySelector('[data-sc-bis]');
  }

  function getBisEmailInput() {
    return document.querySelector('[data-sc-bis-email]');
  }

  function getBisSubmitButton() {
    return document.querySelector('[data-sc-bis-submit]');
  }

  function getBisMessage() {
    return document.querySelector('[data-sc-bis-message]');
  }

  function getPdpRoot() {
    return document.querySelector('[data-city-pdp-root]') ||
      document.querySelector('[data-city-pdp]') ||
      document.querySelector('.t4s-product__info-wrapper') ||
      document.querySelector('.t4s-product__info-container') ||
      document.querySelector('main');
  }

  function getVariantInput() {
    return document.querySelector('[data-city-variant-select]') ||
      document.querySelector('form[data-type="add-to-cart-form"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('input[name="id"]') ||
      document.querySelector('select[name="id"]');
  }

  function isElementVisible(el) {
    if (!el) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(el) : null;

    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) {
      return false;
    }

    if (el.hidden) return false;

    if (el.getClientRects && el.getClientRects().length === 0) {
      return false;
    }

    return true;
  }

  function getCityFromExplicitAttributes() {
    var selectors = [
      '[data-selected-city]',
      '[data-current-city]',
      '[data-city-current]',
      '[data-delivery-city]',
      '[data-sc-current-city]',
      '[data-city-name]',
      '[data-city]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var nodes = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < nodes.length; j += 1) {
        var el = nodes[j];

        if (!isElementVisible(el)) continue;

        var raw =
          el.getAttribute('data-selected-city') ||
          el.getAttribute('data-current-city') ||
          el.getAttribute('data-city-current') ||
          el.getAttribute('data-delivery-city') ||
          el.getAttribute('data-sc-current-city') ||
          el.getAttribute('data-city-name') ||
          el.getAttribute('data-city') ||
          el.textContent ||
          '';

        var city = normalizeCity(raw);

        if (city) return city;
      }
    }

    return '';
  }

  function getCityFromHeaderText() {
    /*
      We only scan likely header/location elements, not the full body.
      Full body scanning is unsafe because the page can contain all city names.
    */
    var selectors = [
      '.t4s-section-header [class*="city"]',
      '.t4s-section-header [class*="location"]',
      '.t4s-section-header [class*="deliver"]',
      '.t4s-header [class*="city"]',
      '.t4s-header [class*="location"]',
      '.t4s-header [class*="deliver"]',
      'header [class*="city"]',
      'header [class*="location"]',
      'header [class*="deliver"]',
      '[data-header] [class*="city"]',
      '[data-header] [class*="location"]',
      '[data-header] [class*="deliver"]',
      '[data-location-current]',
      '[data-current-location]',
      '[data-delivery-location]',
      '[data-location]'
    ];

    var candidates = [];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!isElementVisible(el)) return;

        var text = normalizeText(el.textContent || '');

        if (!text) return;

        var city = normalizeCity(text);

        if (city) {
          candidates.push({
            city: city,
            text: text,
            length: text.length
          });
        }
      });
    });

    if (!candidates.length) return '';

    /*
      Prefer shortest visible city/location text.
      This avoids choosing large containers that may contain multiple cities.
    */
    candidates.sort(function (a, b) {
      return a.length - b.length;
    });

    return candidates[0].city || '';
  }

  function getCityFromStorage() {
    var likelyKeys = [
      'city',
      'selected_city',
      'selectedCity',
      'current_city',
      'currentCity',
      'delivery_city',
      'deliveryCity',
      'sc_city',
      'scCity',
      'sharbatly_city',
      'sharbatlyCity',
      'customer_city',
      'customerCity'
    ];

    var stores = [];

    try {
      stores.push(window.localStorage);
    } catch (e) {}

    try {
      stores.push(window.sessionStorage);
    } catch (e) {}

    for (var s = 0; s < stores.length; s += 1) {
      var store = stores[s];
      if (!store) continue;

      for (var i = 0; i < likelyKeys.length; i += 1) {
        var key = likelyKeys[i];

        try {
          var value = store.getItem(key);
          var city = normalizeCity(value);

          if (city) return city;
        } catch (e) {}
      }

      /*
        Controlled fallback: only inspect keys that include city/location/delivery.
      */
      try {
        for (var k = 0; k < store.length; k += 1) {
          var storageKey = store.key(k);
          var keyText = normalizeText(storageKey);

          if (
            keyText.indexOf('city') === -1 &&
            keyText.indexOf('location') === -1 &&
            keyText.indexOf('delivery') === -1
          ) {
            continue;
          }

          var storageValue = store.getItem(storageKey);
          var valueCity = normalizeCity(storageValue);

          if (valueCity) return valueCity;
        }
      } catch (e) {}
    }

    return '';
  }

  function getSelectedDeliveryCityGroup() {
    return getCityFromExplicitAttributes() ||
      getCityFromHeaderText() ||
      getCityFromStorage() ||
      '';
  }

  function cssEscapeSafe(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value || '').replace(/"/g, '\\"');
  }

  function getSelectedSwatchValueByOptionName(optionName) {
    optionName = normalizeText(optionName);

    if (!optionName) return '';

    var option = document.querySelector(
      '[data-swatch-option][data-option-name="' + cssEscapeSafe(optionName) + '"]'
    );

    if (!option) {
      var allOptions = document.querySelectorAll('[data-swatch-option][data-option-name]');

      allOptions.forEach(function (opt) {
        if (option) return;

        if (normalizeText(opt.getAttribute('data-option-name')) === optionName) {
          option = opt;
        }
      });
    }

    if (!option) return '';

    var selected = option.querySelector('[data-swatch-item].is--selected');

    if (selected) {
      return selected.getAttribute('data-value') || selected.textContent || '';
    }

    var current = option.querySelector('[data-current-value]');

    if (current) {
      return current.textContent || '';
    }

    return '';
  }

  function getSelectedCityValueFromSwatch() {
    var cityGroup = document.querySelector('[data-city-option-group]');

    if (!cityGroup) {
      var options = document.querySelectorAll('[data-swatch-option][data-option-name]');

      options.forEach(function (option) {
        if (cityGroup) return;

        var name = normalizeText(option.getAttribute('data-option-name'));

        if (name === 'city' || name === 'المدينة' || name === 'مدينة') {
          cityGroup = option;
        }
      });
    }

    if (!cityGroup) return '';

    var selected = cityGroup.querySelector('[data-swatch-item].is--selected');

    if (selected) {
      return selected.getAttribute('data-value') || selected.textContent || '';
    }

    var current = cityGroup.querySelector('[data-current-value]');

    if (current) {
      return current.textContent || '';
    }

    return '';
  }

  function getCityOptionPosition() {
    if (!productData || !Array.isArray(productData.optionsWithValues)) return 0;

    for (var i = 0; i < productData.optionsWithValues.length; i += 1) {
      var name = normalizeText(productData.optionsWithValues[i].name);

      if (name === 'city' || name === 'المدينة' || name === 'مدينة') {
        return toInt(productData.optionsWithValues[i].position, i + 1);
      }
    }

    return 0;
  }

  function getVariantData(variantId) {
    if (!productData || !productData.variants) return null;
    return productData.variants[String(variantId)] || null;
  }

  function variantMatchesCityGroup(variant, cityGroup) {
    if (!variant || !cityGroup) return false;

    var values = [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ];

    if (Array.isArray(variant.options)) {
      values = values.concat(variant.options);
    }

    for (var i = 0; i < values.length; i += 1) {
      if (normalizeCity(values[i]) === cityGroup) {
        return true;
      }
    }

    return false;
  }

  function findVariantByDeliveryCity() {
    if (!productData || !productData.variants) return 0;

    var cityGroup = getSelectedDeliveryCityGroup();

    if (!cityGroup) return 0;

    var variants = productData.variants;
    var keys = Object.keys(variants);

    for (var i = 0; i < keys.length; i += 1) {
      var variant = variants[keys[i]];

      if (variantMatchesCityGroup(variant, cityGroup)) {
        return toInt(variant.id, 0);
      }
    }

    return 0;
  }

  function findVariantBySelectedOptions() {
    if (!productData || !productData.variants) return 0;

    var selectedCityFromSwatch = normalizeCity(getSelectedCityValueFromSwatch());
    var cityPosition = getCityOptionPosition();

    if (!selectedCityFromSwatch || !cityPosition) return 0;

    var selectedOptions = {};

    if (Array.isArray(productData.optionsWithValues)) {
      productData.optionsWithValues.forEach(function (option) {
        var position = toInt(option.position, 0);
        var optionName = normalizeText(option.name);

        if (!position || !optionName) return;

        var value = getSelectedSwatchValueByOptionName(optionName);

        if (value) {
          selectedOptions[String(position)] = normalizeText(value);
        }
      });
    }

    var variants = productData.variants;
    var keys = Object.keys(variants);

    for (var i = 0; i < keys.length; i += 1) {
      var variant = variants[keys[i]];
      var cityValue = normalizeCity(variant['option' + cityPosition]);

      if (cityValue !== selectedCityFromSwatch) continue;

      var allOptionsMatch = true;

      Object.keys(selectedOptions).forEach(function (position) {
        if (!allOptionsMatch) return;

        var selectedValue = selectedOptions[position];
        var variantValue = normalizeText(variant['option' + position]);

        if (selectedValue && variantValue && selectedValue !== variantValue) {
          allOptionsMatch = false;
        }
      });

      if (allOptionsMatch) {
        return toInt(variant.id, 0);
      }
    }

    return 0;
  }

  function getCurrentVariantId() {
    /*
      Priority 1:
      Match variant from customer's actual selected delivery city.
      This avoids using stale Kalles hidden select.
    */
    var cityVariantId = findVariantByDeliveryCity();

    if (cityVariantId) return cityVariantId;

    /*
      Priority 2:
      Match selected swatches if visible.
    */
    var matchedVariantId = findVariantBySelectedOptions();

    if (matchedVariantId) return matchedVariantId;

    /*
      Final fallback only.
    */
    var root = getPdpRoot();
    var input = getVariantInput();

    var raw =
      (root && (
        root.getAttribute('data-city-current-variant-id') ||
        root.getAttribute('data-current-city-variant-id') ||
        root.getAttribute('data-city-variant-id')
      )) ||
      document.body.getAttribute('data-city-current-variant-id') ||
      (input && input.value) ||
      '';

    return toInt(raw, 0);
  }

  function getSelectedOptionForVariant(variantId) {
    var input = getVariantInput();

    if (!input || !variantId) return null;

    if (input.tagName === 'SELECT') {
      return input.querySelector('option[value="' + variantId + '"]');
    }

    return null;
  }

  function isVariantAvailable(variantId) {
    var variant = getVariantData(variantId);

    if (variant) {
      var qty = toInt(variant.inventory_quantity, 0);
      var policy = variant.inventory_policy || '';

      if (policy !== 'continue' && qty <= 0) {
        return false;
      }

      return !!variant.available;
    }

    var option = getSelectedOptionForVariant(variantId);

    if (option) {
      var optionQty = toInt(option.getAttribute('data-inventoryQuantity'), 0);
      var optionPolicy = option.getAttribute('data-inventoryPolicy') || '';

      if (option.disabled || option.classList.contains('is--sold-out')) {
        return false;
      }

      if (optionPolicy !== 'continue' && optionQty <= 0) {
        return false;
      }

      return true;
    }

    return true;
  }

  function canUseBackInStock(variantId) {
    var variant = getVariantData(variantId);

    if (variant && variant.inventory_policy === 'continue') {
      return false;
    }

    var option = getSelectedOptionForVariant(variantId);

    if (option) {
      var policy = option.getAttribute('data-inventoryPolicy') || '';
      return policy !== 'continue';
    }

    return true;
  }

  function setMessage(type, text) {
    var el = getBisMessage();
    if (!el) return;

    el.hidden = false;
    el.className = 'sc-bis__message sc-bis__message--' + type;
    el.textContent = text;
  }

  function clearMessage() {
    var el = getBisMessage();
    if (!el) return;

    el.hidden = true;
    el.className = 'sc-bis__message';
    el.textContent = '';
  }

  function setLoading(isLoading) {
    var btn = getBisSubmitButton();
    var input = getBisEmailInput();

    if (btn) {
      btn.disabled = !!isLoading;
      btn.classList.toggle('is-loading', !!isLoading);
      btn.textContent = isLoading
        ? t('Submitting...', 'جارٍ الإرسال...')
        : t('Notify me', 'أعلمني');
    }

    if (input) {
      input.disabled = !!isLoading;
    }
  }

  function updateBisVisibility() {
    var wrap = getBisWrap();

    if (!wrap) return;

    var variantId = getCurrentVariantId();

    if (!variantId) {
      wrap.hidden = true;
      wrap.classList.remove('is-visible');
      return;
    }

    var available = isVariantAvailable(variantId);
    var canUseBis = canUseBackInStock(variantId);

    wrap.setAttribute('data-current-variant-id', String(variantId));
    wrap.setAttribute('data-current-city-group', getSelectedDeliveryCityGroup() || '');

    if (!available && canUseBis) {
      wrap.hidden = false;
      wrap.classList.add('is-visible');
    } else {
      wrap.hidden = true;
      wrap.classList.remove('is-visible');
      clearMessage();
    }
  }

  function scheduleVisibilityUpdate(delay) {
    window.clearTimeout(window.__scBisVisibilityTimer);

    window.__scBisVisibilityTimer = window.setTimeout(
      updateBisVisibility,
      typeof delay === 'number' ? delay : 100
    );
  }

  function buildKlaviyoVariantId(shopifyVariantId) {
    var config = getConfig();
    var prefix = config.variantIdPrefix || '$shopify:::$default:::';
    return prefix + String(shopifyVariantId);
  }

  function submitBackInStock(email, variantId) {
    var config = getConfig();

    if (!config.companyId || config.companyId === 'YOUR_KLAVIYO_PUBLIC_API_KEY') {
      return Promise.reject(new Error('Missing Klaviyo public API key / company ID'));
    }

    var endpoint =
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
      encodeURIComponent(config.companyId);

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: buildKlaviyoVariantId(variantId)
            }
          }
        }
      }
    };

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.status === 202 || res.ok) {
        return true;
      }

      return res.text().then(function (text) {
        throw new Error(text || 'Klaviyo BIS submission failed');
      });
    });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function debugBisState(prefix) {
    var variantId = getCurrentVariantId();

    console.log(prefix || '[SC BIS]', {
      selectedDeliveryCityGroup: getSelectedDeliveryCityGroup(),
      currentVariantId: variantId,
      variantData: getVariantData(variantId),
      available: isVariantAvailable(variantId),
      canUseBackInStock: canUseBackInStock(variantId)
    });
  }

  function handleSubmit(event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    var input = getBisEmailInput();
    var variantId = getCurrentVariantId();

    debugBisState('[SC BIS submit]');

    if (!input || !isValidEmail(input.value)) {
      setMessage(
        'error',
        t('Please enter a valid email address.', 'يرجى إدخال بريد إلكتروني صحيح.')
      );
      return;
    }

    if (!variantId) {
      setMessage(
        'error',
        t(
          'Unable to detect the selected variant. Please refresh and try again.',
          'تعذّر تحديد المنتج المحدد. يرجى تحديث الصفحة والمحاولة مرة أخرى.'
        )
      );
      return;
    }

    if (isVariantAvailable(variantId)) {
      setMessage(
        'error',
        t('This item is currently available.', 'هذا المنتج متوفر حاليًا.')
      );
      updateBisVisibility();
      return;
    }

    clearMessage();
    setLoading(true);

    submitBackInStock(input.value.trim(), variantId)
      .then(function () {
        setMessage(
          'success',
          t(
            'Thank you. We’ll notify you when this item is back in stock.',
            'شكرًا لك. سنخبرك عند توفر هذا المنتج مرة أخرى.'
          )
        );

        input.value = '';
      })
      .catch(function (err) {
        console.warn('[SC BIS] Klaviyo BIS error', err);

        setMessage(
          'error',
          t(
            'We could not submit your request. Please try again.',
            'تعذّر إرسال طلبك. يرجى المحاولة مرة أخرى.'
          )
        );
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function initForm() {
    var btn = getBisSubmitButton();
    var input = getBisEmailInput();

    if (btn) {
      btn.addEventListener('click', handleSubmit);
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleSubmit(event);
        }
      });
    }
  }

  document.addEventListener('city:changed', function () {
    scheduleVisibilityUpdate(160);
    window.setTimeout(updateBisVisibility, 500);
  });

  document.addEventListener('variant:changed', function () {
    scheduleVisibilityUpdate(120);
  });

  document.addEventListener('variant:change', function () {
    scheduleVisibilityUpdate(120);
  });

  document.addEventListener('click', function (event) {
    if (
      event.target &&
      event.target.closest &&
      event.target.closest('[data-swatch-item], [data-city-option-group] [data-swatch-item], [class*="city"], [class*="location"], [class*="deliver"]')
    ) {
      scheduleVisibilityUpdate(80);
      window.setTimeout(updateBisVisibility, 260);
      window.setTimeout(updateBisVisibility, 600);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (
      event.target &&
      event.target.matches &&
      event.target.matches('[data-city-variant-select], form[action*="/cart/add"] [name="id"], input[name="id"], select[name="id"]')
    ) {
      scheduleVisibilityUpdate(100);
    }
  });

  var root = getPdpRoot();

  if (root && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      scheduleVisibilityUpdate(120);
    });

    observer.observe(root, {
      attributes: true,
      attributeFilter: [
        'data-city-current-variant-id',
        'data-current-city-variant-id',
        'data-city-variant-id',
        'data-city-current-variant-available',
        'data-current-city-variant-available',
        'data-city-variant-available'
      ]
    });
  }

  /*
    Expose debug helper for browser console:
    window.scBisDebug()
  */
  window.scBisDebug = function () {
    debugBisState('[SC BIS debug]');
  };

  initForm();

  scheduleVisibilityUpdate(100);
  window.setTimeout(updateBisVisibility, 400);
  window.setTimeout(updateBisVisibility, 1000);
  window.setTimeout(updateBisVisibility, 1800);
})();